import { getCookie } from 'mmbclient/Common/CommonFunctions';
import { AD, EP, GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME } from 'mmbclient/Common/CommonVariable'
import React, { useContext } from 'react'
import StockIncomingController from './StockIncomingController';
import DatePicker from 'react-datepicker';
import CircularSpinner from 'mmbclient/Components/CircularSpinner';
import { RenderPagination } from 'mmbclient/Components/RenderPagination';
import "./StockIncoming.css";

function StockIncoming() {
    
    const store = useContext(GLOBAL_CONTEXT);
    const {currentItems, currentPage, setCurrentPage, totalPages, itemPerPage, startDate, setStartDate, endDate, setEndDate, client, setClient, clientOption, loading, showModal, setShowModal, modalType, modalMessage, betterLoggerFunction,searchItem, setSearchItem, handleClick, exportToCSV, exportToExcel} = StockIncomingController(store);

  return (
    <>
            {/* Bootstrap Modal */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {/* <div className={`modal-header alert-${modalType}`}> */}
                        <div className={`modal-header alert-${modalType} d-flex justify-content-between`}>
                            <h5 className="modal-title" id="modalLabel">Alert</h5>
                            <button type="button" className="close" style={{border: 'none',background: 'none'}} onClick={() => setShowModal(false)} aria-label="Close">
                                <span aria-hidden="true" style={{fontSize:'32px'}}>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {modalMessage}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner/>}
                <div className="container mt-2">
                        <div className="text-center">
                            <h1 style={{fontSize:'20px'}}>Stock Incoming</h1>
                        </div>
                        <hr className='my-2'/>
                        <div className='row mb-2'>

                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) == EP)?
                                <div className="col-md-3">
                                    <label className="form-label small-label">Client</label>
                                    <select className='form-select small-input' value={client} onChange={e=>setClient(e.target.value)}>
                                            {
                                                clientOption.map((option,index)=>{
                                                   return(
                                                     <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                )
                                                })
                                            }
                                    </select>
                                </div>
                                :null
                            }

                            <div className='col-md-2'>
                                <label className='form-label small-label'>Start Date</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={e =>setStartDate(e)}
                                    className="form-control small-input"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </div>

                            <div className='col-md-2'>
                                <label className='form-label small-label'>End Date</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={ e => setEndDate(e)}
                                    className='form-control small-input'
                                    dateFormat="dd//MM/yyyy"
                                />
                            </div>

                            <div className='col-md-1 d-flex align-items-end'>
                                <button className="btn btn-primary mt-2 small-input" style={{ height: "40px" }} 
                                onClick={() => {
                                                    handleClick();
                                                    setCurrentPage(1);
                                                }}>
                                    Search
                                </button>
                            </div>
                        </div>    
                        <hr className='my-2'/>

                        <div className="mb-3 d-flex align-items-center">
                                <input 
                                    type='text' 
                                    placeholder="Search..."
                                    className="form-control me-2 flex-grow-1 small-input"
                                    value={searchItem} 
                                    onChange={e => {
                                        setSearchItem(e.target.value)
                                        setCurrentPage(1);
                                        }}/>

                                <div className="dropdown">
                                    <button 
                                        className="btn btn-primary dropdown-toggle small-input"
                                        type="button"
                                        id="dropdownMenuButton"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        Export
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                        <li>
                                            <button className="dropdown-item small-input" onClick={exportToCSV}>Export to CSV</button>
                                        </li>
                                        <li>
                                            <button className="dropdown-item small-input" onClick={exportToExcel}>Export to Excel</button>
                                        </li>
                                    </ul>
                                </div>
                        </div>    

                        <div className="table-responsive">
                            <table className="table table-bordered table-striped small-input">
                                <thead>
                                        <tr>
                                            <td>SNo</td>
                                            {
                                            (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)?
                                                    <td>Client</td>:null
                                            }
                                            <td>Network</td>
                                            <td>Awb Range</td>
                                            <td>Awb No</td>
                                            <td>In Date</td>
                                            <td>Expiry Date</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentItems.length>0?(
                                                currentItems.map((item,index)=>(
                                                    <tr key={index}>
                                                        <td>{index + 1 + (currentPage - 1) * itemPerPage}</td>
                                                        {
                                                            (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)?
                                                            <td>{item.client_name}</td>:null
                                                        }
                                                        <td>{item.network_name + " | " + item.network_code}</td>
                                                        <td>{item.original_range}</td>
                                                        <td>{item.awb_no}</td>
                                                        <td>{item.in_date}</td>
                                                        <td>{item.exp_date}</td>
                                                    </tr>
                                                ))
                                            ):(
                                                <tr>
                                                    <td colSpan="13" className="text-center">No Data Found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                    <ul className="pagination justify-content-center">
                                        <RenderPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
                                    </ul>
                            </nav>
                        </div>    
                </div>
            </div >
        </>
  )
}

export default StockIncoming
